module.exports = __webpack_public_path__ + "static/img/loading.ddeaf60f.gif";